import { useEffect } from "react";

const ClaimElement = ({ claim, type = null }: any) => {
  // useEffect(() => {
  //   console.log({ claimElementsClaim: claim })
  // }, [claim])

  return (
    <div className="">
      {type === "vijilize" && (
        <div className="px-4 py-3 border-b border-[#CED2DA]">
          <p className="text-base font-interSemiBold text-[#0A090B]">
            Claim Features
          </p>
          <p className="leading-none opacity-0">
            <span className="text-xs text-[#0A090B] font-interMedium">
              Similarity Score:
            </span>
            <span className="text-xs font-interSemiBold text-[#1D7C4D]">
              {" "}
              80%
            </span>
          </p>
        </div>
      )}

      <div className="px-5 py-4">
        {
          Array.isArray(claim?.claim_preamble) || Array.isArray(claim?.preamble) ? (
            <div>
              {(Array.isArray(claim?.claim_preamble) ? claim.claim_preamble : claim.preamble).map((cp: any, cpIndex: number) => (
                <span key={cpIndex} style={{ color: cp.hex_code }}>
                  {cp.description}{' '}
                </span>
              ))}
            </div>
          ) : (
            <div>
              <span style={{ color: claim?.hex_code }}>
                {claim?.claim_preamble || claim?.preamble}
              </span>
            </div>
          )
        }

        {
          claim.elements &&
          claim.elements.map((element: any, elemIndex: number) => (
            <div key={elemIndex} className="ml-7">
              {element?.features?.length > 0 ? (
                // New structure: render features array on same line
                element?.features?.map((feature: any, featureIndex: number) => (
                  <span key={featureIndex} style={{ color: feature.hex_code }}>
                    {feature.description}
                  </span>
                ))
              ) : (
                // Current structure: render element description directly
                <span style={{ color: element?.hex_code }}>
                  {element?.description}
                </span>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ClaimElement;
